import { Bot } from 'lucide-react';
import { Button, useOverlayState } from '@heroui/react';
import { AssistantDrawer } from './assistant-drawer';
import { ASSISTANT_SUCCESS_BUTTON_STYLE } from './assistant-success-style';

export function AssistantMenu() {
  const drawerState = useOverlayState();

  return (
    <>
      {drawerState.isOpen ? null : (
        <Button
          isIconOnly
          variant="primary"
          aria-label="Assistente LinkPark"
          onPress={drawerState.open}
          data-tour="assistant-fab"
          className="fixed z-50 size-14 min-h-14 min-w-14 rounded-full shadow-lg right-4 bottom-[calc(5.5rem+env(safe-area-inset-bottom))] md:right-6 md:bottom-6 md:size-16 md:min-h-16 md:min-w-16"
          style={ASSISTANT_SUCCESS_BUTTON_STYLE}
        >
          <Bot className="size-7 md:size-8" />
        </Button>
      )}
      <AssistantDrawer state={drawerState} />
    </>
  );
}
